"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-san-martino": {
    "6f0bb605": [{
      "hkey": "41549cbe",
      "slug": "monte-san-martino",
      "name": "Monte San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "barchetta": [{
      "hkey": "41549cbe",
      "slug": "monte-san-martino",
      "name": "Monte San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4421337d": [{
      "hkey": "41549cbe",
      "slug": "monte-san-martino",
      "name": "Monte San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-santa-maria-maddalena": [{
      "hkey": "41549cbe",
      "slug": "monte-san-martino",
      "name": "Monte San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3631fc14": [{
      "hkey": "41549cbe",
      "slug": "monte-san-martino",
      "name": "Monte San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "41549cbe",
      "slug": "monte-san-martino",
      "name": "Monte San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;